import React, { memo, ReactElement } from "react";
import classNames from "classnames";
import styles from "../BillDetailItem.scss";
interface SeparatorProps {
    isInTooltip?: boolean;
}

const Separator = ({ isInTooltip = false }: SeparatorProps): ReactElement => {
    const className = classNames({
        [styles.separator]: true,
        [styles.separatorInTooltip]: isInTooltip,
    });

    return <div className={className} />;
};

export default memo(Separator);
